import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { Sport } from '#src/__generated__/globalTypes.ts';
import { withFragments } from '#src/lib/gql/index.ts';
import { usesCardDesign2026 } from '#src/lib/seasons.ts';

import { anyCardStatsOverlay2025 } from './Stats/anyCard/2025/index.tsx';
import { anyCardStatsOverlay2026 } from './Stats/anyCard/2026/index.tsx';
import { baseballStatsOverlay2025 } from './Stats/baseball/2025/index.tsx';
import { footballStatsOverlay2024 } from './Stats/football/2024/index.tsx';
import { nbaStatsOverlay2024 } from './Stats/nba/2024/index.tsx';
import type { statsOverlay_AnyCardInterface } from './__generated__/statsOverlay.graphql.ts';

export const statsOverlay = withFragments(
  (card_: statsOverlay_AnyCardInterface) => {
    const card = card_;
    if (card.sport === Sport.FOOTBALL) {
      if (
        usesCardDesign2026({
          seasonYear: card.seasonYear,
          singleCivilYear: card.singleCivilYear,
        })
      ) {
        return anyCardStatsOverlay2026(card);
      }
      if (card.seasonYear >= 2025) {
        return anyCardStatsOverlay2025(card);
      }
      if (card.seasonYear >= 2024) {
        return footballStatsOverlay2024(card);
      }
    }
    if (card.sport === Sport.NBA) {
      if (card.seasonYear >= 2025) {
        return anyCardStatsOverlay2025(card);
      }
      if (card.seasonYear >= 2024) {
        return nbaStatsOverlay2024(card);
      }
    }
    if (card.sport === Sport.BASEBALL) {
      if (card.seasonYear >= 2026) {
        return anyCardStatsOverlay2025(card);
      }
      if (card.seasonYear >= 2025) {
        return baseballStatsOverlay2025(card);
      }
    }
    return undefined;
  },
  {
    AnyCardInterface: gql`
      fragment statsOverlay_AnyCardInterface on AnyCardInterface {
        slug
        sport
        seasonYear
        singleCivilYear
        ...footballStatsOverlay2024_AnyCardInterface
        ...anyCardStatsOverlay2025_AnyCardInterface
        ...anyCardStatsOverlay2026_AnyCardInterface
        ...nbaStatsOverlay2024_AnyCardInterface
        ...baseballStatsOverlay2025_AnyCardInterface
      }
      ${footballStatsOverlay2024.fragments.AnyCardInterface}
      ${anyCardStatsOverlay2025.fragments.AnyCardInterface}
      ${anyCardStatsOverlay2026.fragments.AnyCardInterface}
      ${nbaStatsOverlay2024.fragments.AnyCardInterface}
      ${baseballStatsOverlay2025.fragments.AnyCardInterface}
    ` as TypedDocumentNode<statsOverlay_AnyCardInterface>,
  }
);
